import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { requery } from "../../../actions/updateHelp";
import ReactDatatable from "@ashvin27/react-datatable";
import { withRouter } from "react-router-dom";
import * as myConstList from "../../../BaseUrl";
import { Modal } from "react-bootstrap";
import moment from "moment";
import axios from "axios";
import { baseUrl } from "../../../BaseUrl";
const callBackBaseUrl = myConstList.callBackBaseUrl;
class RedeemeHistory extends React.Component {
  constructor(props) {
    super(props);
    const { user } = this.props.auth;
    this.state = {
      records: [],
      id: this.props.id,
      description: "",
      message: "",
      username: user.name,
      singleVoucherData: [],
      isModalOpen: false,
      voucherName: "",
      showResults: false,
      showTeaxtArea: true,
      urltemp: "",
      errors: {},
    };
    // reactData Table
    this.columns = [
      {
        key: "",
        text: "S. No.",
        classNameName: "contestName",
        align: "left",
        sortable: true,
        cell: (row, index) => index + 1,
      },
      {
        key: "remark",
        text: "Transaction Type",
        classNameName: "contestName",
        align: "left",
        sortable: true,
      },
      {
        key: "coin_points",
        text: "Redeem Amount",
        classNameName: "winningAmount",
        align: "left",
        sortable: true,
        cell: (record) => <Fragment>{Math.abs(record.coin_points)}</Fragment>,
      },
      {
        key: "tx_id",
        text: "Transaction ID",
        classNameName: "winningAmount",
        align: "left",
        sortable: true,
      },
      {
        key: "rewardName",
        text: "Reward",
        classNameName: "numOfParticipation",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              <button
                className="btn btn_man"
                onClick={() => this.voucherDetails(record)}
              >
                {record.rewardName}
              </button>
            </Fragment>
          );
        },
      },
      {
        key: "startDate",
        text: "Date",
        classNameName: "startDate",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{moment(record.date).format("lll")}</Fragment>;
        },
      },
      {
        key: "status",
        text: "Status",
        classNameName: "startDate",
        align: "left",
        sortable: true,
      },
    ];
  }
  voucherDetails = (data) => {
    this.setState({ isModalOpen: true, voucherName: data.rewardName });
    var voucherData = {
      voucherId: data.voucher_id,
    };
    axios.post(baseUrl + "api/get-voucher-details", voucherData).then((res) => {
      var resp = res.data;
      if (resp.success === true) {
        this.setState({ singleVoucherData: resp.data });
      }
    });
  };
  componentDidMount() {
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.record) {
      this.setState({
        records: nextProps.record,
      });
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.auth !== undefined &&
      nextProps.auth.user !== undefined &&
      nextProps.auth.user.data !== undefined &&
      nextProps.auth.user.data.message !== undefined &&
      nextProps.auth.user.data.success
    ) {
      this.setState({
        message: nextProps.auth.user.data.message,
      });
    }
  }
  closeWhitelistModal = () => {
    this.setState({ isModalOpen: false });
  };

  voucherDetailsHtml = () => {
    const html = [];
    this.state.singleVoucherData.map((item, i) => {
      return html.push(
        <tr>
          <td>{item.name}</td>
          <td>
            <a href={item.link}>Click Here</a>
          </td>
          <td>
            <img
              className="img-fluid"
              src={baseUrl + "static/offerImage/" + item.image}
              alt="voucher"
              width={100}
              height={100}
            />
          </td>
          <td>{item.description}</td>
        </tr>
      );
    });
    return html;
  };

  render() {
    return (
      <div className="crypt-market-status2 mt-4 p-2 p-sm-3">
        <div className=" table-striped mb-0">
          <div className="ccrool_table">
            <ReactDatatable
              records={this.state.records}
              columns={this.columns}
            />
          </div>
        </div>
        <Modal show={this.state.isModalOpen} onHide={this.closeWhitelistModal}>
          <Modal.Header>Voucher Information</Modal.Header>
          <Modal.Body>
            <table className="table table-responsive">
              <tr>
                <th>Name</th>
                <th>Url</th>
                <th>Image</th>
                <th>Description</th>
              </tr>
              <tbody>{this.voucherDetailsHtml()}</tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-close"
              onClick={this.closeWhitelistModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

RedeemeHistory.propTypes = {
  requery: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { requery })(
  withRouter(RedeemeHistory)
);
